import { useState, useEffect } from 'react';

const useBlogPost = (id) => {
    const [post, setPost] = useState(null);
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!id) return;

        setLoading(true);
        setNotFound(false);

        Promise.all([
            fetch('/posts/index.json').then((r) => r.json()),
            fetch(`/posts/${id}.md`).then((r) => {
                if (!r.ok) throw new Error('not found');
                return r.text();
            }),
        ])
            .then(([posts, markdown]) => {
                const meta = posts.find((p) => p.id === id);
                if (!meta) throw new Error('not found');
                setPost(meta);
                setContent(markdown);
                setLoading(false);
            })
            .catch(() => {
                setNotFound(true);
                setLoading(false);
            });
    }, [id]);

    return { post, content, loading, notFound };
};

export default useBlogPost;
